import React from 'react';
import { styles } from './CardOverlay.css';
import CloseIcon from '@jbhi-fi/lanyard-ui/components/Icons/Close';
import CartIcon from '@jbhi-fi/lanyard-ui/components/Icons/Cart';
import { useNavigate } from '../../PlatformFunctionality';
import Button from '@jbhi-fi/lanyard-ui/components/Button/Button';
import { trackCheckoutTriggered } from '@jbhi-fi/utils/src/ga4Tracking/functions/trackCheckoutTriggered';
import { removeSession, SessionStorageKeys } from '@jbhi-fi/utils/src/sessionStorage';

export type CardOverlayVariant = 'checkout' | 'wishlist' | null;

export type CardOverlayProps = {
  activeOverlay: CardOverlayVariant;
  onClose: () => void;
  onCreateAccount: (event: React.MouseEvent) => void;
  onLogin: (event: React.MouseEvent) => void;
};

export const CardOverlay = ({ activeOverlay, onClose, onCreateAccount, onLogin }: CardOverlayProps) => {
  const navigateTo = useNavigate();

  return (
    <div className={styles.overlay({ activeOverlay: Boolean(activeOverlay) })}>
      <div className={styles.overlayCloseButton}>
        <CloseIcon
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            onClose();
          }}
        />
      </div>
      {activeOverlay === 'checkout' ? (
        <>
          <div className={styles.overlayTitle}>
            <CartIcon className={styles.cartIcon} />
            Item added to your cart!
          </div>

          <Button
            classes={styles.overlayButton}
            type="primary"
            label="View cart"
            fullWidth
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              window.dataLayer?.push({
                event: 'overlay-view-cart',
              });
              navigateTo('/cart');
            }}
          />
          <Button
            classes={styles.overlayButton}
            type="action"
            label="Checkout"
            fullWidth
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              trackCheckoutTriggered({
                triggerSource: 'product_tile',
              });
              window.dataLayer?.push({
                event: 'overlay-checkout',
              });
              removeSession(SessionStorageKeys.CachedCart);
              navigateTo('/checkout');
            }}
          />
        </>
      ) : (
        <>
          <div className={styles.overlayTitle} data-testid="wishlist-card-overlay-message">
            You&apos;re one step away from having this in your wishlist!
          </div>
          <div className={styles.overlayWishlistButtonContainer}>
            <Button
              data-testid="wishlist-card-overlay-create-account-button"
              classes={styles.overlayButton}
              type="primary"
              label="Create account"
              fullWidth
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                onCreateAccount(e);
              }}
            />
            <Button
              data-testid="wishlist-card-overlay-login-button"
              classes={styles.overlayButton}
              type="secondary"
              label="Log in"
              fullWidth
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                onLogin(e);
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};
